import { VyTextField, type VyTextFieldProps } from '@vy/ui-design-system';
import { Controller, type FieldPath, type FieldValues } from 'react-hook-form';
import { useFieldController } from './useFieldController';

export type VyTextFieldFieldProps<TForm extends FieldValues> = Omit<
  VyTextFieldProps,
  'value' | 'onChange' | 'onBlur' | 'error' | 'helperText' | 'inputRef'
> & {
  name: FieldPath<TForm>;
  /** Hint shown below the field when no error message is present. */
  helperText?: string;
};

export function VyTextFieldField<TForm extends FieldValues>({
  name,
  helperText,
  ...rest
}: VyTextFieldFieldProps<TForm>) {
  const { control, message } = useFieldController<TForm>(name);
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <VyTextField
          {...rest}
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          inputRef={field.ref}
          error={Boolean(message)}
          helperText={message ?? helperText}
        />
      )}
    />
  );
}
